import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withAppContext } from '../../contexts/app';
//import { Link } from 'react-router-dom';

import ImageUploader from '../../components/ImageUploader';

import SidebarMenu from '../../layout/SidebarMenu';

/*
const HeaderButtons = () => {
  return (
    <div className="results-view__head__buttons">
      <div className="button--gradient">Save my results</div>
      <div className=""><i className="icon icon--share" />Share my results</div>
    </div>
  );
};
*/

const malignancyColors = {
  malignant: 'red',
  premalignant: 'yellow'
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = this.resolveState(props);
  }

  UNSAFE_componentWillReceiveProps(props) {
    this.setState(this.resolveState(props));
  }

  resolveState(props) {
    const menuItems = props.predictions.map((prediction) => {
      let color;

      if (props.type === 'dermoscopic') {
        color = malignancyColors[prediction.condition.malignancy];
      } else {
        if (prediction.condition.highRisk) { color = 'red'; }
      }

      return {
        id: prediction.condition.id,
        label: prediction.condition.commonName,
        color: color
      };
    });

    return { menuItems };
  }

  render() {
    return (
      <div className="sidebar results__sidebar">
        <div className="content">
          <SidebarMenu
            style="midnight-blue"
            numbered={true}
            items={this.state.menuItems}
            onItemClick={this.props.onItemClick}
            bottom={this.sidebarBottom()}
          />

          <div className="results-view__sidebar-disclaimer">
            Triage does not provide health advice, diagnosis or treatment.
            &nbsp;<a href="/terms" target="_blank">Learn more</a>
          </div>

          {/*<HeaderButtons />*/}
        </div>
      </div>
    );
  }

  sidebarBottom() {
    return (
      <div className="results__sidebar__top">
        <div className="results__sidebar__top__left">
          <p>Results don&apos;t look right?</p>
        </div>

        <div className="results__sidebar__top__right">
          {/*<Link to="/get-started" className="button button--medium button--gradient">Scan skin again</Link>*/}

          <ImageUploader
            className="button button--medium button--gradient get-started-link"
            label="Try again"
            onUpload={this.onImageUpload.bind(this)}
          />
        </div>
      </div>
    );
  }

  onImageUpload(image) {
    this.props.app.onImageUpload(image);
  }
}

Sidebar.defaultProps = {
  predictions: [],
  onItemClick: ()=>{},
  menuItems: undefined,
};

Sidebar.propTypes = {
  app: PropTypes.object.isRequired,
  type: PropTypes.string,
  predictions: PropTypes.array,
  menuItems: PropTypes.array,
  onItemClick: PropTypes.func
};

export { Sidebar };
export default withAppContext(Sidebar);
